<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
	<modal-header-default class="border"> </modal-header-default>
	<div class="intro-container">
		@let holdsBestPan = holdsBestOrPan$ | async;
		<!-- @let holdsVision = holdsVision$ | async; -->
		@if (migrationFF$ | async; as migration) {
			<div class="heading-holder">
				<h4 class="headline"> {{ "web3_migration_intro_heading" | translate }}</h4>

				<p class="description">
					@if (migration.phase === phase.PostMerge) {
						{{
							"web3_migration_intro_post_subheading"
								| translate: [migration.mergeDate | date_format: { month: "long", day: "numeric" }]
						}}
					} @else {
						{{
							"web3_migration_intro_subheading"
								| translate: [migration.mergeDate | date_format: { month: "long", day: "numeric" }]
						}}
					}
				</p>
				@if (migration.phase === phase.PreMerge) {
					<p class="cover">{{ "w3st_migration_text_cover_title" | translate }}</p>
				}
			</div>
			<div class="info-holder">
				<div class="info-item">
					<svg-inline
						src="/assets/images/intro-slippage-icon.svg"
						[alt]="'web3_migration_text_cover_title' | translate" />
					<div class="info-text">
						<span class="title-text"> {{ "web3_migration_text_cover_title" | translate }}</span>
						<span class="sub-text">
							{{ "web3_migration_text_cover_sub" | translate }}
						</span>
					</div>
				</div>
				<div class="info-item">
					<svg-inline
						src="/assets/images/intro-percentage-icon.svg"
						[alt]="'web3_migration_text_staking_title' | translate" />
					<div class="info-text">
						<span class="title-text"> {{ "web3_migration_text_staking_title" | translate }}</span>
						<span class="sub-text">
							{{ "web3_migration_text_staking_sub" | translate }}
						</span>
					</div>
				</div>
				<div class="info-item">
					<svg-inline
						src="/assets/images/intro-trends-icon.svg"
						[alt]="'web3_migration_text_opportunities_title' | translate" />
					<div class="info-text">
						<span class="title-text"> {{ "web3_migration_text_opportunities_title" | translate }}</span>
						<span class="sub-text">
							{{ "web3_migration_text_opportunities_post_sub" | translate }}
						</span>
					</div>
				</div>
			</div>

			<div class="button-holder">
				<button (click)="next()" class="btn btn-primary next-btn"> {{ "Weiter" | translate }}</button>
			</div>
		}
	</div>
</div>
